var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"case-tabs"},[_c('div',{class:['case-tab', _vm.current_tab == 'Sifarnik' ? 'active' : '',],on:{"click":function($event){return _vm.changeView('sifarnik')}}},[_vm._v(" "+_vm._s(_vm.$t('sifrarnici_tab.t1'))+" ")]),_c('div',{class:[
        'case-tab',
        _vm.current_tab == 'Tarife' ? 'active' : '',
      ],on:{"click":function($event){return _vm.changeView('tarife')}}},[_vm._v(" "+_vm._s(_vm.$t('sifrarnici_tab.t2'))+" ")]),_c('div',{class:[
        'case-tab',
        _vm.current_tab == 'Predlošci' ? 'active' : '',
      ],on:{"click":function($event){return _vm.changeView('template-docx')}}},[_vm._v(" "+_vm._s(_vm.$t('sifrarnici_tab.t3'))+" ")]),_c('div',{class:[
        'case-tab',
        _vm.current_tab == 'TroskovnikReportEdit' ? 'active' : '',
      ],on:{"click":function($event){return _vm.changeView('troskovnik-report-edit')}}},[_vm._v(" "+_vm._s(_vm.$t('sifrarnici_tab.t4'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }